module.exports = __webpack_public_path__ + "static/media/person_gourmet.55ed28fe.jpg";